import { ElasticContentContainer } from '@cdab/scania/qpr/components/atoms'
import { TdsBadge, TdsDivider } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledElasticContentContainer = styled(ElasticContentContainer)`
  height: calc(100% - var(--tds-header-height));
`

export const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow-y: scroll;
  flex-grow: 1;
  background-color: var(--tds-grey-50);
  height: 100%;
`

export const StyledUploadingMessage = styled.div`
  opacity: 0.5;
  display: flex;
  flex-direction: row-reverse;
`

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tds-spacing-element-8);
`

export const ChatHeaderWrapper = styled.div`
  background: white;
  border-bottom: 1px solid #dbdfe6;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
`

export const ActionRow = styled.div`
  align-items: center;
  background: white;
  background: white;
  border-bottom: 1px solid #dbdfe6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 0;
  padding: 8px;
  height: 60px;
`

export const ActionRowTitle = styled.h4`
  margin-right: 4px;
  text-transform: capitalize;
  display: flex;
  justify-content: center;
`

export const StyledBadges = styled(TdsBadge)`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const ChatMessageFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const ContextMenuWrapper = styled.div<{ x: number; y: number }>`
  position: fixed;
  top: ${({ y }) => y}px;
  left: ${({ x }) => x}px;
  z-index: 9999;
`

export const StyledText = styled.p.attrs({
  className: 'tds-body-03'
})`
  margin-left: 4px;
  color: var(--tds-red-400);
`

export const NewMessagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StyledDivider = styled(TdsDivider)`
  width: 100%;
  --tds-divider-background: var(--tds-red-400);
`
